import React, { FC } from "react";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import Modal from 'react-modal'
import { useLocale } from "../../contexts/localeContext";
import { FloorDetails } from "./FloorDetails";
import { Form, Formik} from "formik";
import closeIcon from '../../images/close.svg';
import { Floor } from "../../models/Floor";

interface FloorModalProps {
    isOpen: boolean;
    onClose: () => void;
    saveFloor: (value) => void,
    initialValues: Floor
}

const FloorModal: FC<FloorModalProps> = ({ isOpen, onClose, saveFloor, initialValues }) => {
    const { translate } = useLocale();

    return (
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
            className="bg-white border-none m-auto shadow select-none outline-none w-content">
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={saveFloor}>
                <Form>
                    <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
                        <div className="flex flex-row">
                            <p className="pl-3 font-bold font text-white">{translate.byKey(TranslationKeys.assignFloor)}</p>
                        </div>
                        <img src={closeIcon} onClick={onClose} className="cursor-pointer mr-2" />
                    </div>
                    <div className="pt-3 pl-8 pr-0" style={{ width: '400px' }} >
                        <FloorDetails />
                    </div>
                    <div className="flex flex-row pb-3 pr-3 justify-end bg-white">
                        <div className="flex flex-row mt-4 mr-5">
                            <button
                                id='submitBtn'
                                className="secondary secondary-enabled py-1 px-5"
                                type='submit'>
                                {translate.byKey(TranslationKeys.submit)}
                            </button>
                        </div>
                    </div>
                </Form>
            </Formik>
        </Modal>
    )
}

export default FloorModal;
